import React from "react";
import DatePicker from "react-datepicker";
import DatacenterList from "../../common/DatacenterList/DatacenterList";
import { apiRequest } from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import FinancialTable from "./FinancialTable/FinancialTable";
import PropertyDetailView from "./PropertyDetailView/PropertyDetailView";
import FinancialTableGrid from "./FinancialTableGrid/FinancialTableGrid";
import ViewComfyIcon from "@material-ui/icons/ViewComfy";
import { IconButton, Tooltip } from "@material-ui/core";
import TocIcon from "@material-ui/icons/Toc";
import BackspaceIcon from "@material-ui/icons/Backspace";
import PointCompare from "./PointCompare/PointCompare";
import { IsSectionVisible } from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import { countBy, sortBy } from "lodash/collection";
class Financial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datacenterList: undefined,
      selectedPropertyId: localStorage.getItem("selectedPropertyId"),
      startDate: localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L"), // localStorage.getItem("selectedstartDate"),
      endDate: localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L"),
     
      PickerStartDate: localStorage.getItem("selectedstartDate")
        ? new Date(
            moment(localStorage.getItem("selectedendDate")) > new Date()
              ? new Date()
              : moment(localStorage.getItem("selectedendDate"))
                  .startOf("month")
                  .format("L")
          )
        : new Date(),
      cardView: false,
      propertyDetailView: false,
      compareView: false,
      PropertyDetailById: [],
      PropertySummaryList: [],
      productByCount: {},
      siteProfileList: [],
      compareForDcId: undefined,
      compareForDcName: undefined,
      compareForDcKey: undefined,
      selectedDcName: undefined,
    };
    this.switchToComparisonView = this.switchToComparisonView.bind(this);
    localStorage.setItem(
      "selectedstartDate",
      localStorage.getItem("selectedstartDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .startOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .startOf("month")
              .format("L")
        : moment()
            .startOf("month")
            .format("L")
    );
    localStorage.setItem(
      "selectedendDate",
      localStorage.getItem("selectedendDate")
        ? moment(localStorage.getItem("selectedendDate")) > new Date()
          ? moment()
              .endOf("month")
              .format("L")
          : moment(localStorage.getItem("selectedendDate"))
              .endOf("month")
              .format("L")
        : moment()
            .endOf("month")
            .format("L")
    );

    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem(
      "MTDDefault",
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("MM")
    );
    localStorage.setItem("yearDefault", [
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("YYYY"),
      moment(localStorage.getItem("selectedendDate"))
        .endOf("month")
        .format("YYYY"),
    ]);
  }

  componentWillMount() {}

  componentDidMount() {
    if (this.state.datacenterList == undefined) {
      this.getDataCenterList();
    }

    this.GetSteProfileDataByDate(0);
  }

  /** call on text change filed */
  _handleTextFieldChange = (e) => {
    const input = e;
    const output = moment(input, "YYYY-MM");
    localStorage.setItem(
      "selectedstartDate",
      output.startOf("month").format("L")
    );
    localStorage.setItem("selectedendDate", output.endOf("month").format("L"));
    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem("DateRadioSelect", "MTD");
    localStorage.setItem("MTDDefault", output.endOf("month").format("MM"));
    localStorage.setItem("yearDefault", [
      output.endOf("month").format("YYYY"),
      output.endOf("month").format("YYYY"),
    ]);

    this.setState(
      {
        startDate: output.startOf("month").format("L"),
        endDate: output.endOf("month").format("L"),
        PickerStartDate: e,
      },
      () => {
        if (
          this.state.propertyDetailView &&
          this.state.selectedPropertyId !== undefined
        ) {
          this.fetchPropertyDetails(
            this.getDwId(parseInt(this.state.selectedPropertyId))
          );
        }
        this.fetchDataCenterListWithData(localStorage.getItem("IdList"));
        this.GetSteProfileDataByDate(0);
      }
    );
  };

  /** On property select */
  onPropertySelect = (id) => {
    localStorage.setItem("selectedPropertyId", id);
   const {datacenterList,propertyDetailView}= this.state;
    const name = (
      (datacenterList || []).find(
        (x) => (x.propertyID == id && x.dwPropertyId > 0) == true
      ) || {}
    ).name;
    if (propertyDetailView && id !== undefined) {
      this.fetchPropertyDetails(this.getDwId(parseInt(id)));
    }
    this.setState({ selectedPropertyId: id, selectedDcName: name });
  };

  /** Data center list */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: datacenterList }) => {
        const IdList = [];
        datacenterList.map((item) => {
          if (item.dwPropertyId > 0) {
            IdList.push(item.dwPropertyId);
          }
        });
        localStorage.setItem("IdList", IdList.join(","));
        this.fetchDataCenterListWithData(IdList.join(","));

        this.setState({
          datacenterList: datacenterList,
        });
      }
    );
  };

  /** property details */
  fetchPropertyDetails = (id) => {
    const params = {
      id: id,
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      datePeriodType: "MTD",
    };

    apiRequest({
      url: API_URL.finance.GetPropertyFinanceDetails,
      params,
    }).then(({ data: List }) => {
      const Sorted = this._groupBy(List.data, "attributeName");

      localStorage.setItem("selectedPropertyId", this.getPropertyId(id));
      this.setState({
        propertyDetailView: true,
        PropertyDetailById: Sorted,
        selectedPropertyId: this.getPropertyId(id),
      });
    });
  };

  /** property Id */
  getDwId = (DcID) => {
    const data = this.state.datacenterList;
    let a;
    data.map((item) => {
      if (item.propertyID == DcID) {
        a = item.dwPropertyId;
      }
    });
    return a;
  };

  /** property Id */
  getPropertyId = (DcID) => {
    const data = this.state.datacenterList;
    let a;
    data.map((item) => {
      if (item.dwPropertyId == DcID) {
        a = item.propertyID;
      }
    });
    return a;
  };

  /** property name by id */
  getNameById = (DcID) => {
    const data = this.state.datacenterList;
    let a;
    data.map((item) => {
      if (item.dwPropertyId == DcID) {
        a = item.name;
      }
    });
    return a;
  };

  /** swtich view */
  switchToComparisonView(KeyPoint, id, KeyPointName) {
    // console.log(KeyPoint, id);
    const name = this.getNameById(id);
    this.setState({
      compareView: true,
      compareForDcId: id,
      compareForDcName: name,
      compareForDcKey: KeyPointName,
    });
  }

  /** profile data */
  GetSteProfileDataByDate = (propertyId) => {
    const params = {
      propertyId: propertyId,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };

    apiRequest({
      url: API_URL.datacenter.GetDataHallCapacityByProperty,
      params,
    }).then(({ data: List }) => {
      this.setState({
        siteProfileList: List,
      });
    });
  };

  /** Data center list with data */
  fetchDataCenterListWithData(IdList) {
    const params = {
      id: IdList, //"293,367,2145,3498",
      startDate: moment(this.state.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.state.startDate).format("YYYY-MM-DD"),
    };

    apiRequest({
      url: API_URL.finance.GetPropertyFinanceSummaryByPropertyKey,
      params,
    }).then(({ data: PropertyFinanceList }) => {
      console.log(PropertyFinanceList);
      const Sorted = this._groupBy(JSON.parse(JSON.stringify([...PropertyFinanceList.data])));
      const sortData = sortBy(JSON.parse(JSON.stringify([...Sorted])), x => x.length && x[0].productType);
      this.setState({ PropertySummaryList: JSON.parse(JSON.stringify([...sortData])), 
         productByCount: countBy(JSON.parse(JSON.stringify([...sortData])), d => d[1].productType) });
    });
  }

  /** group by */
  _groupBy(myArray) {
    const groups = {};
    for (let i = 0; i < myArray.length; i++) {
      const groupName = myArray[i].propertyKey;
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(myArray[i]);
    }
    myArray = [];
    for (const groupName in groups) {
      myArray.push(groups[groupName]);
    }
    // console.log(myArray);
    return myArray;
  }
  render() {
    const PropertyDetailViewSection = IsSectionVisible(
      SECTIONS.FINANCIAL,
      SECTIONS.FINANCIAL_PROPERTY
    );

    const PropertyCompareViewSection = IsSectionVisible(
      SECTIONS.FINANCIAL,
      SECTIONS.FINANCIAL_GRAPH_COMPARE
    );

    return (
      <Grid container>
        <Grid item xs={12}>
          <Grid container className={"reports-row-one"}>
            <Grid item xs={12} md={6}>
              <Box className={"w-25 reports-dcList"}>
                {this.state.compareView == false &&
                this.state.propertyDetailView == true ? (
                  <DatacenterList
                    dataSource={(this.state.datacenterList || []).filter(
                      (x) => x.dwPropertyId > 0
                    )}
                    onPropertySelect={this.onPropertySelect}
                    classTitle={"dc-list-reports"}
                    selectedPropertyId={this.state.selectedPropertyId}
                  />
                ) : null}
              </Box>
            </Grid>

            <Grid item xs={12} md={6} justifyContent={"flex-end"}>
              <Box className={"reports-datepicker"}>
                {this.state.compareView ? (
                  <Tooltip title={"Back to table list"}>
                    <IconButton size={"small"}>
                      <BackspaceIcon
                        size={"small"}
                        onClick={() => {
                          this.setState({
                            compareView: false,
                          });
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                ) : this.state.propertyDetailView ? (
                  <Tooltip title={"Back to Data Center List"}>
                    <IconButton size={"small"}>
                      <BackspaceIcon
                        size={"small"}
                        onClick={() => {
                          this.setState({
                            propertyDetailView: false,
                          });
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                ) : this.state.cardView ? (
                  <Tooltip title={"Switch to Table View"}>
                    <IconButton size={"small"}>
                      <TocIcon
                        size={"small"}
                        onClick={() => {
                          this.setState({
                            cardView: false,
                          });
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                ) : (
                  <Tooltip title={"Switch to Card View"}>
                    <IconButton size={"small"}>
                      <ViewComfyIcon
                        size={"small"}
                        onClick={() => {
                          this.setState({
                            cardView: true,
                          });
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}

                <DatePicker
                  selected={this.state.PickerStartDate}
                  onChange={(date) => this._handleTextFieldChange(date)}
                  dateFormat={"MMMM yyyy"}
                  showMonthYearPicker
                  maxDate={new Date()}
                  popperPlacement={"bottom-end"}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Box>
                {this.state.compareView == false ? (
                  this.state.propertyDetailView ? (
                    <PropertyDetailView
                      PropertyDetail={this.state.PropertyDetailById}
                      switchToComparisonView={this.switchToComparisonView}
                      selectedDcName={this.state.selectedDcName}
                      startDate={this.state.startDate}
                      PropertyCompareViewSection={PropertyCompareViewSection}
                    />
                  ) : this.state.cardView ? (
                    <FinancialTableGrid
                      getPropertyDetail={this.fetchPropertyDetails}
                      listData={this.state.PropertySummaryList}
                      datacenterList={this.state.datacenterList}
                      siteProfileList={this.state.siteProfileList}
                      startDate={this.state.startDate}
                      PropertyDetailViewSection={PropertyDetailViewSection}
                    />
                  ) : (
                    <FinancialTable
                      getPropertyDetail={this.fetchPropertyDetails}
                      listData={this.state.PropertySummaryList}
                      productByCount={this.state.productByCount}
                      datacenterList={this.state.datacenterList}
                      siteProfileList={this.state.siteProfileList}
                      startDate={this.state.startDate}
                      PropertyDetailViewSection={PropertyDetailViewSection}
                    />
                  )
                ) : (
                  <PointCompare
                    allListData={this.state.PropertySummaryList}
                    PropertyDetail={this.state.PropertyDetailById}
                    datacenterList={this.state.datacenterList}
                    DataHallCapacityList={this.state.siteProfileList}
                    compareForDcId={this.state.compareForDcId}
                    compareForDcName={this.state.compareForDcName}
                    compareForDcKey={this.state.compareForDcKey}
                    startDate={this.state.startDate}
                  />
                )}

                {/* <PointCompare /> */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Box mt={2}>
                {/* <FinancialTable
                  title={"List of Major Variances"}
                  type={"Variances"}
                /> */}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
export default Financial;
